import { Fragment } from 'react';
import { NavLink, Link } from 'react-router-dom';

const Footer = () => {
    return (
        <Fragment>
            <footer id="footer" className="footer light-background">
                <div className="container footer-top">
                    <div className="row gy-4">
                        <div className="col-lg-4 col-md-6 footer-about">
                            <a href="/" className="logo d-flex align-items-center">
                                <img src="assets/images/logo/imagotipo-blanco.png" alt="" />
                            </a>
                            <div className="footer-contact pt-3">
                                <p><strong>Email:</strong> <span>contacto@goodlic.com</span></p>
                                <p><strong>Teléfono:</strong> <span>+52 442 297 1928</span></p>
                            </div>
                            <div className="social-links d-flex mt-4">
                                <a href="https://wa.me/524422971928" target="_blank" rel="noreferrer"><i className="bi bi-whatsapp"></i></a>
                                <a href="https://www.facebook.com/profile.php?id=61550659125692" target="_blank" rel="noreferrer"><i className="bi bi-facebook"></i></a>
                                <a href="https://www.instagram.com/goodlic.mx" target="_blank" rel="noreferrer"><i className="bi bi-instagram"></i></a>
                                <a href=""><i className="bi bi-linkedin"></i></a>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-3 footer-links">
                            <ul>
                                <li><a href="#hero">Inicio</a></li>
                                <li><a href="#about">Nuestra historia</a></li>
                                <li><a href="#services">Nuestros servicios</a></li>
                                <li><a href="#services">Casos de éxito</a></li>
                                <li><a href="#pricing">Membresías</a></li>
                            </ul>
                        </div>

                        <div className="col-lg-4 col-md-3 footer-links">
                            <ul>
                                <li><a href="#contact">Contáctanos</a></li>
                                <li><NavLink to="/terminos-y-condiciones">Términos y condiciones</NavLink></li>
                                <li><NavLink to="/aviso-de-privacidad">Aviso de privacidad</NavLink></li>
                                <li><a href="/login">Iniciar sesión</a></li>
                                <li><a href="/register">Crear cuenta</a></li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="container copyright text-center mt-4">
                    <p><span>Desarrollado por </span><strong className="px-1 sitename"><a className="solgeek" href="https://solgeek.com/" target="_blank" rel="noreferrer">Solgeek</a></strong></p>
                </div>
            </footer>

            <a href="#" id="scroll-top" className="scroll-top d-flex align-items-center justify-content-center"><i className="bi bi-arrow-up-short"></i></a>

            <div id="preloader"></div>
        </Fragment>
    )
}

export default Footer;